<template>
  <div>
    <div
      v-if="isElegible"
      class="fit-content rounded-pill py-2 pl-2 pr-3 text-nowrap text-white bg-green font-weight-bold"
    >
      <i class="fas fa-check-circle mx-1" />
      <span class="ml-1">Elegible</span>
    </div>
    <template v-else>
      <div
        class="fit-content d-inline-block rounded-pill py-2 pl-2 pr-3 text-nowrap text-white mr-2 font-weight-bold"
        :class="[hasConsent ? 'bg-green' : 'bg-red']"
      >
        <i class="fas fa-signature mx-1" />
        <span v-if="!hasConsent" class="ml-1">Falta</span>
        <span class="ml-1">Consentimiento</span>
      </div>
      <div
        class="fit-content d-inline-block rounded-pill py-2 pl-2 pr-3 text-nowrap text-white font-weight-bold"
        :class="[hasMedicalPlan ? 'bg-green' : 'bg-red']"
      >
        <i class="fas fa-briefcase-medical mx-1" />
        <span v-if="!hasMedicalPlan" class="ml-1">Falta</span>
        <span class="ml-1">Plan Médico</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MedicalPlanBadges',
  props: {
    hasConsent: {
      type: Boolean,
      default: () => false,
    },
    hasMedicalPlan: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    isElegible() {
      return this.hasMedicalPlan && this.hasConsent;
    },
  },
};
</script>

<style scoped>
.fit-content {
  width: fit-content;
}
</style>
